export default "__VITE_ASSET__COicPen3__"